import { useIntl } from 'react-intl';

import { useTargetingContext } from '@/contexts/Targeting/TargetingContext';
import { AudienceProfile } from '../AudienceProfile';

import './audienceListHeader.scss';

type Props = {
  onAddAudienceProfile: () => void;
};

function AudienceListHeader({ onAddAudienceProfile }: Props) {
  const { formatMessage } = useIntl();
  const { user } = useTargetingContext();

  return (
    <div className="audienceListHeader">
      <span className="audienceListHeader__title">
        {formatMessage({
          defaultMessage: 'Audience list',
          id: 'targeting.audienceTargeting.audienceList.title'
        })}
      </span>
      <div>
        <AudienceProfile onAddAudienceProfile={onAddAudienceProfile} user={user} />
      </div>
    </div>
  );
}

export default AudienceListHeader;
